__turbopack_context__.v({
  "content": "YmkE1G_content",
  "list": "YmkE1G_list",
  "listScrollButton": "YmkE1G_listScrollButton",
  "listScrollButtonLeft": "YmkE1G_listScrollButtonLeft",
  "listScrollButtonRight": "YmkE1G_listScrollButtonRight",
  "listScrollHost": "YmkE1G_listScrollHost",
  "listScrollHostOverflowing": "YmkE1G_listScrollHostOverflowing",
  "listScrollable": "YmkE1G_listScrollable",
  "tabs": "YmkE1G_tabs",
  "trigger": "YmkE1G_trigger",
});
